// extracted by mini-css-extract-plugin
export var avatarContainer = "_cj-0";
export var avatarTypingWave = "_cj-i";
export var gray = "_cj-f";
export var green = "_cj-c";
export var icon = "_cj-9";
export var image = "_cj-1";
export var lg = "_cj-6";
export var md = "_cj-5";
export var presenceDot = "_cj-b";
export var red = "_cj-d";
export var sm = "_cj-4";
export var status = "_cj-a";
export var typingDot = "_cj-h";
export var typingPill = "_cj-g";
export var xl = "_cj-7";
export var xs = "_cj-3";
export var xxl = "_cj-8";
export var xxs = "_cj-2";
export var yellow = "_cj-e";